import { makeStyles } from "@mui/styles";
import { COLORS } from "theme";
import { Theme } from "@mui/material/styles";

export const useStyles = makeStyles((theme: Theme) => ({
    content:{
        background:COLORS.MODAL_BG,
    },
}));